
import Sidebar from "./Sidebar";
export default function Dashboard(){
    return(<div className="w-screen pt-[2%] px-[1%] h-[100vh]  bg-[#f1f2f6] flex flex-row">
           <Sidebar/>
           
    </div>)
}